import axios from "axios"

const BureauService = {}

BureauService.ajouter =(formData,authorization)=>{
return axios.post(`${process.env.REACT_APP_API_URL}/bureau/ajouter`, formData ,{
    headers: { 'Authorization': `Bearer ${authorization}` }
})

}
export default BureauService ;